export const BLOG_POSTS = [
  {
    slug: "best-physiotherapist-in-bagnan-guide",
    title: "How to Choose the Best Physiotherapist in Bagnan — A 2026 Guide",
    excerpt:
      "Everything you should check before booking a physiotherapy session in Bagnan — from qualifications and specialisations to home-visit logistics and honest pricing.",
    date: "2026-01-08",
    cover:
      "https://images.pexels.com/photos/7789616/pexels-photo-7789616.jpeg",
    author: "Sk Zishan Physio",
    read: "6 min read",
    body: [
      "Choosing a physiotherapist near Bagnan is not just about who is closest — it is about who can actually get you back to living your life pain-free. The wrong clinic can waste months.",
      "**1. Verify qualifications.** A recognised physiotherapy qualification (such as a DPT) is the minimum. Ask about specialisations — neuro, ortho or sports.",
      "**2. Look for a proper assessment.** A good physiotherapist spends 20–30 minutes on the first visit understanding your history, imaging and movement patterns before prescribing treatment.",
      "**3. Insist on a written plan.** How many sessions? What outcomes? Home exercises? If a clinic can't tell you, keep looking.",
      "**4. Home-visit availability.** For stroke, post-surgery and elderly patients, home physiotherapy in Bagnan removes travel stress and delivers better outcomes.",
      "**5. Transparent pricing.** Ask about per-session cost, travel charges (for home visits) and any package discounts up front.",
      "At Mita Physio Cure we combine all five: a certified physiotherapist, structured assessment, written plans, home visits across Bagnan-Howrah and no hidden fees.",
    ],
  },
  {
    slug: "home-physiotherapy-bagnan-benefits",
    title: "Home Physiotherapy in Bagnan: 7 Reasons It Works Better Than a Clinic",
    excerpt:
      "For elderly patients, post-surgery recovery and stroke rehab, home physiotherapy often delivers dramatically better outcomes. Here's why.",
    date: "2026-01-02",
    cover:
      "https://images.pexels.com/photos/20860610/pexels-photo-20860610.jpeg",
    author: "Sk Zishan Physio",
    read: "5 min read",
    body: [
      "Home physiotherapy is not a luxury — for many patients in Bagnan and Howrah, it is medically the best option.",
      "**1. Zero travel stress** for elderly and post-op patients.",
      "**2. Realistic environment** — we assess stairs, toilets and beds the patient actually uses.",
      "**3. Family involvement** — caregivers learn the exercises in real time.",
      "**4. One-on-one focus** — the entire session belongs to one patient.",
      "**5. Better compliance** — home exercises are built around your daily routine.",
      "**6. Infection safety** — especially important for immuno-compromised patients.",
      "**7. Cost effective** for a full recovery cycle vs. daily commuting.",
      "Book a home physiotherapy visit in Bagnan on WhatsApp: +91 74777 07139.",
    ],
  },
  {
    slug: "stroke-rehabilitation-early-days",
    title: "Stroke Rehabilitation: Why the First 90 Days Matter Most",
    excerpt:
      "Neuroplasticity is highest in the early months after a stroke. Here's how structured physiotherapy in the first 90 days transforms recovery.",
    date: "2025-12-18",
    cover:
      "https://images.pexels.com/photos/20860625/pexels-photo-20860625.jpeg",
    author: "Sk Zishan Physio",
    read: "7 min read",
    body: [
      "After a stroke, the brain's ability to rewire — called neuroplasticity — is highest in the first 3 months. Every session of physiotherapy in this window has an outsized impact on long-term function.",
      "**Week 1–2:** Positioning, passive range-of-motion, prevention of contractures and pressure sores.",
      "**Week 3–6:** Task-oriented training — reaching for a glass, standing balance, transfers.",
      "**Week 7–12:** Gait re-training, community mobility, fine motor tasks and reintegration into daily life.",
      "We deliver this protocol at home across Bagnan, Amta and Uluberia so the survivor never has to compromise on early, intensive rehabilitation.",
    ],
  },
  {
    slug: "back-pain-treatment-bagnan-office-workers",
    title: "Back Pain Treatment in Bagnan for Desk Workers — What Actually Works",
    excerpt:
      "Sitting 8+ hours a day is silently wrecking your spine. A physiotherapy-based approach beats painkillers every time.",
    date: "2025-12-10",
    cover:
      "https://images.pexels.com/photos/20860625/pexels-photo-20860625.jpeg",
    author: "Sk Zishan Physio",
    read: "5 min read",
    body: [
      "If your lower back aches after a day of desk work, medication only masks the problem. The fix is postural correction + core activation + mobility work.",
      "**Root causes** — weak deep core, tight hip flexors, poor workstation ergonomics, and prolonged sitting.",
      "**Our approach** — manual therapy for immediate relief, then McKenzie extensions, glute activation and workstation coaching.",
      "**Most patients** feel 60–70% better in 3 weeks and stay pain-free if they keep the 10-minute daily routine.",
    ],
  },
  {
    slug: "sciatica-treatment-bagnan",
    title: "Sciatica: Why Rest Alone Won't Fix It",
    excerpt:
      "That sharp pain from lower back into the leg? Bed rest may feel good — but it makes sciatica worse. Here's the physiotherapy plan that actually solves it.",
    date: "2025-12-01",
    cover:
      "https://images.pexels.com/photos/7789616/pexels-photo-7789616.jpeg",
    author: "Sk Zishan Physio",
    read: "6 min read",
    body: [
      "Sciatica is a symptom — usually a compressed or irritated sciatic nerve — not a diagnosis. Treating it requires finding what's compressing the nerve.",
      "**Common causes** — disc herniation, piriformis syndrome, spinal stenosis.",
      "**Physiotherapy plan** — nerve gliding techniques, McKenzie extension protocol, deep gluteal release, and progressive core stabilisation.",
      "**Timeline** — most patients see clear improvement within 4–6 sessions. Complete resolution typically 8–12 weeks with consistent home exercises.",
    ],
  },
  {
    slug: "frozen-shoulder-recovery",
    title: "Frozen Shoulder: The 3-Stage Recovery Timeline You Should Know",
    excerpt:
      "Frozen shoulder can lock up your arm for 12–18 months if untreated. A staged physiotherapy programme can cut that in half.",
    date: "2025-11-22",
    cover:
      "https://images.pexels.com/photos/20860610/pexels-photo-20860610.jpeg",
    author: "Sk Zishan Physio",
    read: "5 min read",
    body: [
      "Frozen shoulder (adhesive capsulitis) goes through three predictable stages — freezing, frozen, thawing.",
      "**Freezing (pain dominant):** Focus on pain relief modalities and gentle ROM to prevent worsening stiffness.",
      "**Frozen (stiffness dominant):** Capsular stretching, joint mobilisation and scapular re-education.",
      "**Thawing (movement returns):** Progressive resistance training and full return to functional activities.",
      "Book an assessment at Mita Physio Cure — early diagnosis + right-stage treatment = faster recovery.",
    ],
  },
];
